module.exports = __webpack_public_path__ + "static/media/top_banner_6.aa4d8014.png";